import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { mapCompanySizeToLabel } from "@/mappers/companies";
import { GetCompanyByIdResponse } from "@/requests/companies/company-by-id.request";
import { Building4 } from "iconsax-react";
import { FC } from "react";

type CompanyMetaProps = {
  company: GetCompanyByIdResponse | undefined;
  isLoading: boolean;
};

const CompanyMeta: FC<CompanyMetaProps> = ({ company, isLoading }) => {
  return (
    <div>
      <div className="flex items-center">
        <Building4 size={16} className="mr-2 text-[#9491CF]" />
        {isLoading && (
          <Skeleton className="my-1 h-3 bg-gray-300" style={{ width: 100 }} />
        )}
        {company && (
          <span className="text-#293038 text-sm">{company?.name}</span>
        )}
      </div>

      {company?.segment && (
        <div className="mt-2 flex flex-wrap gap-2">
          <Badge variant="purple">Sector: {company.segment.sector}</Badge>
          <Badge variant="orange">
            Sub-sector: {company.segment.subsector}
          </Badge>
          <Badge variant="gold">
            Tamaño: {mapCompanySizeToLabel(company.segment.companySize)}
          </Badge>
        </div>
      )}
    </div>
  );
};

export default CompanyMeta;
